module.exports = __webpack_public_path__ + "2b700f0b55e1b8de8887cc9fef75bc2c.png";